import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as BaseLayout, Main } from '@/shared/components/layout/layout';
import Header from '@/shared/components/layout/Header';
import PasswordChangeModal, { PasswordChangeMode } from '@shared/components/modal/PasswordChangeModal';
import { useAuthStore } from '@store/useAuthStore';

const RootLayout = () => {
	return (
		<BaseLayout>
			<Outlet />
		</BaseLayout>
	);
};

const AppLayout = () => {
	const { admin } = useAuthStore();
	const passwordChangeMode: PasswordChangeMode | null = admin?.passwordChangeRequired
		? admin.passwordChangeReason === 'EXPIRED'
			? 'expired'
			: admin.passwordChangeReason === 'FIRST_LOGIN'
				? 'first'
				: admin.passwordChangeReason === 'TEMP_PASSWORD'
					? 'temp'
					: null
		: null;

	return (
		<>
			<Header />
			<Main>
				<Outlet />
			</Main>
			{passwordChangeMode && (
				<PasswordChangeModal
					mode={passwordChangeMode}
					required
				/>
			)}
		</>
	);
};

const FullScreenRouteLayout = () => {
	return <Outlet />;
};

export { RootLayout };

// 기존 라우트 import 호환용 alias
export const HeaderLayout = memo(AppLayout);
export const FullLayout = memo(FullScreenRouteLayout);
export const AppRouteLayout = memo(AppLayout);
export const FullScreenLayout = memo(FullScreenRouteLayout);
